import React from 'react'
import { Dot, DotsContainer, LoadingContainer } from "../styles"

const LoadingPayment = () => {
  return (
    <LoadingContainer>
      <DotsContainer>
        <Dot delay={0} />
        <Dot delay={0.16} />
        <Dot delay={0.32} />
      </DotsContainer>
      <span>Aguarde enquanto realizamos a cobrança...</span>
    </LoadingContainer>
  )
}

export default LoadingPayment